import { Exchange } from "urql";
import { map, pipe } from "wonka";

export const omitTypenameExchange: Exchange =
  ({ forward }) =>
  (operations$) =>
    pipe(
      operations$,
      map((op) => {
        if (op.kind === "mutation" || op.kind === "query") {
          const newOp = { ...op };
          if (newOp.variables) {
            const omitTypename = (key: string, value: any) =>
              key === "__typename" ? undefined : value;
            newOp.variables = JSON.parse(
              JSON.stringify(newOp.variables),
              omitTypename
            );
          }
          return newOp;
        } else {
          return op;
        }
      }),
      forward
    );
